<template>
  <pre_input :value="value" :label="label" :md="md" :tag="c_tag" :view_only="view_only" >
<!-- @click:clear="$emit('update:value', null)" -->
<!-- @click:clear="()=> model = null || change()" -->
<!-- @click:clear="search = ''; model = null;items=[]" -->
<!-- @change="change" -->
  <v-combobox
    v-model="model"
    :search-input.sync="search"
    :label="label"
    :prepend-icon="prepend_icon"
    :append-icon="append_icon"
    :item-text="item_key"
    clearable
    @change="change_m"
    @click:clear="(e)=>change_m(null,e)"
    :return-object="return_object"
    :items="string_items"
      no-filter>
        <template v-slot:append-item>
          <div v-intersect="endIntersect"></div>
        </template>
    </v-combobox>
    <inf_scroll
      v-if="checked_get"
      :is_intersecting="is_intersecting"
      :m_search="search"
      :main_rq_name="name_all_computed"
      :name="`inf-${name}`"
      :ex_filters="ex_filters"
      :items.sync="items" />
  </pre_input>
</template>

<script>
import pre_input_js from '@/components/mixins/pre_input';
import Debounce from '@/components/Debounce';
import filter_rq from './filter_rq';
import inf_scroll_js from './inf_scroll.js';

export default {
  props:{
    sync_v:{default:false},
    f_key:{},
    items_on_search:{default:true},
    reset_on_value_change:{default:false},//uso normal usa los datos previos, pero para modals de editar y/o crear, se necesitan limpios o con la info de es reg y no la anterior
  },
  mixins: [ filter_rq, Debounce, pre_input_js, inf_scroll_js  ],
  data(){
    return {
      model: null,
      items: [],
      filter_rq_type:['<','>'],
    }
  },
  computed: {
    k_f(){ return this.f_key || `s__${this.item_key}` },
        /* si la lista tiene numero y es tipo numero, search-input da error*/
    string_items(){  
      const l = this.items.map(m=>{ return typeof m == 'object'? {...m}:m});
      return this.items_on_search && this.search?l.map(m => (m[this.item_key] = m[this.item_key]+'') && m):[]
    },
    filter() {
      if (!this.myRequestStatus) return null;
      return this.myRequestStatus.filter;
    },
  },
  watch: {
    'search'(v,v_old){
      if (v === null && v_old === null) return;// valor xdef es null asi evita la primera carga
      this.debounceM('search', ()=>this.searchM(v,v_old));
    },
    /* 'model'(v_m,v_m_o) {
      this.dev_log({v_m,v_m_o});
    } */
  },
  methods: {
    change_m(val,ev){
      //solo es usando cuando value es para un formulario y no para filtros para los cuales este componente esta hecho
      if (this.value_key) {
        if (typeof val === 'object' && val != null){
          if (val[this.value_key] != this.value) this.$emit('update:value', val[this.value_key]);
        }
        else if (typeof val === 'string' || val === null && this.value != null)  this.$emit('update:value', '');
      }
    },
    set_model(only_cache) {
      if (this.return_object){
        const ex_f = {}[this.k_f] = this.value[this.item_key];
        const rq = this.get_rq(ex_f,only_cache);
        rq
          .then(r => {
            (((r || {}).results || r) || []).find(f => this.model = f[this.value_key]);
            return r
          })
      } else {
        const a_w = this.reset_on_value_change ? 'search' : (this.myRequestStatus.rq? 'model':'search');
        if (this.value_key) {
          const ex_f = {};
          ex_f[this.value_key] = this.value;

          //valor anterior de otro item que uso este componente. deberia ser mejor que detecte cuando este componente se oculta y ahi reiniciar ese valor, pero no se puede detectar eso
          if (this.value && this.model != this.value && this.filter[this.k_f] != this.search && this.reset_on_value_change) this.filter[this.k_f] = null;

          this.get_rq(ex_f,false)
            .then(r => {
              const items = (((r || {}).results || r) || []);

              const f = items.find(f => f[this.value_key] === this.value) || {};
              if (a_w == 'search') {
                this.items = items;
                this.search = f[this.item_key];
              }
              return r
            })
        } else {
          const ex_f = {};
          ex_f[this.k_f] = this.value;
          const rq = this.get_rq(ex_f,only_cache);
          rq.then(r => {
            this.model = this.value;
            return r
          })
        }
      }
    },
    upd(){
      if (this.return_object) {
        this.$emit('update:value', this.model);
        return
      }
      if (this.value_key) {
        if (this.model) this.$emit('update:value', this.model[this.value_key]);
        return
      }
      if(this.value !== this.search)  this.$emit('update:value', this.search);
      this.dev_log('...');
    },
    then_get_rows(r) {
      /* si hay filtros activos, sino mejor no mostrar una lista q podria confundir al usuario */
      //this.dev_log({r},this.myRequestStatus_filter);/* q aqui sea la validacion por filterBy */
      if (this.values(this.myRequestStatus_filter)) this.items = (((r || {}).results || r) || []);
      return r;
    },
  },
};
</script>
